import { Box, Tab } from '@material-ui/core'
import { useConferenceChuchu } from 'hooks/useConferenceChuchu'
import { enRules } from 'interfaces/IUser'
import { useState, useEffect, ChangeEvent } from 'react'
import { useSelector } from 'react-redux'
import { IState } from 'store'

import CriticalOrders from './CriticalOrders'
import RoutesOver from './RoutesOver'
import { TitlePage, ContainerPage, Tabs } from './styles'

const Conference = () => {
  const { recoveryConference } = useConferenceChuchu()
  const userPermissions = useSelector<IState, enRules[]>(state => state.user.userPermissions)
  const hasPermission = userPermissions.includes(enRules.SeparationCheckCriticalOrder)
  const requestedTab = new URLSearchParams(window.location.search).get('tab')
  const [tab, setTab] = useState(hasPermission && requestedTab === 'routes-over' ? 1 : 0)

  const onChange = (_: ChangeEvent<{}>, newValue: number) => {
    setTab(newValue)
  }

  useEffect(() => {
    // Verifica se há um parâmetro na URL indicando que acabou de finalizar uma conferência
    const urlParams = new URLSearchParams(window.location.search)
    const skipRecovery = urlParams.get('skipRecovery')

    if (!skipRecovery) {
      recoveryConference()
    }
  }, [])

  useEffect(() => {
    if (hasPermission && requestedTab === 'routes-over') {
      setTab(1)
    }
  }, [hasPermission, requestedTab])

  return (
    <ContainerPage style={{ height: 'auto' }}>
      <TitlePage>Conferência</TitlePage>
      <Box>
        <Tabs value={tab} onChange={onChange} centered>
          <Tab label="Pedidos críticos" />
          {hasPermission && <Tab label="Rotas estouradas" />}
        </Tabs>
      </Box>
      <Box>
        {tab === 0 && <CriticalOrders />}
        {tab === 1 && hasPermission && <RoutesOver />}
      </Box>
    </ContainerPage>
  )
}

export default Conference
